import { format, isSameDay, isSameWeek, isSameMonth, parseISO } from "date-fns";

export function getCadence(equipmentType) {
    if (!equipmentType) return null;
    if (equipmentType.daily_inspection) return "daily";
    if (equipmentType.weekly_inspection) return "weekly";
    if (equipmentType.monthly_inspection) return "monthly";
    return null;
}

export function periodLabel(cadence) {
    if (cadence === "daily") return "today";
    if (cadence === "weekly") return "this week";
    if (cadence === "monthly") return "this month";
    return null;
}

export function isInCurrentPeriod(dateStr, cadence) {
    if (!dateStr || !cadence) return false;
    const date = parseISO(dateStr);
    const now = new Date();
    if (cadence === "daily") return isSameDay(date, now);
    if (cadence === "weekly") return isSameWeek(date, now, { weekStartsOn: 1 });
    if (cadence === "monthly") return isSameMonth(date, now);
    return false;
}

export function currentPeriodParams(cadence) {
    const now = new Date();
    if (cadence === "monthly" || cadence === "daily") {
        return { year: now.getFullYear(), month: now.getMonth() + 1 };
    }
    if (cadence === "weekly") {
        return { year: now.getFullYear() };
    }
    return {};
}

export function formatDate(dateStr) {
    if (!dateStr) return "—";
    try {
        return format(parseISO(dateStr), "MM/dd/yyyy");
    } catch {
        return dateStr;
    }
}
